import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PreLoader from "../pre-loader/Preloader";
import { getConfig } from "../../services/environment";
import '../Pages/responsive.css';

const useStyles = makeStyles({
  header: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  banner: {
    width: "100%",
    maxWidth: 1920,
    objectFit: "cover",
    aspectRatio: 9.09,
    maxHeight: 212,
  },
});

export default function Header(props) {
  const { styling } = props;
  const classes = useStyles();
  const image = `${getConfig.baseUrl}${styling?.headerImage?.uri}`;
  const imageAltText = `${styling?.pageTitle || 'Parking'} header banner`;

  return (
    <section className={classes.header} style={{ backgroundColor: styling?.headerColor }}>
      {image && <img src={image} alt={imageAltText} className={classes.banner} />}
      <PreLoader />
    </section>
  );
}
